import { Lock } from 'lucide-react';
import { QUOTE_STATUS_LABEL, QuoteStatus } from '../../types/admin';

/** Shown at the top of sub-pages when the quote is not in Draft status. */
export function ReadOnlyBanner({ status }: { status: QuoteStatus }) {
  return (
    <div className="flex items-center gap-2 mb-4 px-4 py-3 rounded-xl bg-ember/10 border border-ember/30">
      <Lock size={14} className="shrink-0 text-ember" />
      <p className="text-[13px] text-ember font-medium leading-snug">
        Status: <span className="font-semibold">{QUOTE_STATUS_LABEL[status]}</span>
        {' '}— only Draft quotes can be edited.
      </p>
    </div>
  );
}
